import { csrf } from "./request";
import { showToast } from "../utils/toast";

const FORM = "form.pl-ats-filters";

function chosen(wrap: HTMLElement): string[] {
  return Array.from(wrap.querySelectorAll<HTMLInputElement>('input[name="stages[]"]:checked')).map((i) => i.value);
}

function saved(wrap: HTMLElement): string[] {
  try {
    return JSON.parse(wrap.dataset.saved || "[]") as string[];
  } catch {
    return [];
  }
}

const same = (a: string[], b: string[]): boolean => a.length === b.length && a.every((v, i) => v === b[i]);

async function save(wrap: HTMLElement, stages: string[]): Promise<boolean> {
  try {
    const response = await fetch(wrap.dataset.url || "", {
      method: "PUT",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": csrf() },
      body: JSON.stringify({ config: { stages } }),
    });
    return response.ok;
  } catch {
    return false;
  }
}

export function initAtsStages(): void {
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(FORM)) return;
    const wrap = form.querySelector<HTMLElement>("[data-ats-stages]");
    if (!wrap) return;

    const stages = chosen(wrap);
    if (same(stages, saved(wrap))) {
      wrap.querySelectorAll<HTMLInputElement>('input[name="stages[]"]').forEach((i) => { i.disabled = true; });
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    void save(wrap, stages).then((ok) => {
      if (!ok) { showToast("Couldn't save the stage view", "error"); return; }
      wrap.dataset.saved = JSON.stringify(stages);
      form.requestSubmit();
    });
  }, true);
}
